import "./App.scss";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./components/Login/Login";
import Home from "./components/Home/Home";
import ProtectedRoute from "./components/ProtectedRoute";
import { getInfraDev } from "./runtimeConfig";

function App() {
  const disableAuth = !!getInfraDev();

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={<Navigate to={disableAuth ? "/home" : "/login"} replace />}
        />
      </Routes>
    </Router>
  );
}

export default App;
